import { delay } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import SearchAction from '../Redux/Search';


export function* getSearchResult(api, action) {
    yield call(delay, 100);
    // make the call to the api
    const response = yield call(api.searchTag, action.keyword);
    //
    if (response.ok) {
        yield put(SearchAction.fetch(response.data.items));
    } else {

    }
}

export function* getSearchCatalogResult(api, action) {
    yield call(delay, 100);
    const tag = action.args.tag.trim();
    const catalogKeyword = action.args.catalogKeyword.trim();
    const filter = [(tag ? `+"${tag}"` : ""), (catalogKeyword ? `+${catalogKeyword}` : "")].join(" ").trim();
    // make the call to the api
    const response = yield call(api.searchCatalog, filter);
    //
    if (response.ok) {
        yield put(SearchAction.fetchCatalog(response.data.items));
    } else {

    }
}
